import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2 d-flex align-items-center font-24 text-success"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-alert_success",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "font-weight-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.withIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.message), 1))
    ]),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}